import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import {
  FitBoundsOptions,
  LatLngBounds,
  LatLngBoundsExpression,
  LatLngExpression,
  Point,
  ZoomPanOptions,
} from 'leaflet';

const flyToWithOffset = (
  map: ReturnType<typeof useMap>,
  latlng: LatLngExpression | null,
  zoom: number | null,
  offset: { x: number; y: number } | null,
  options: ZoomPanOptions
) => {
  const targetZoom = zoom ?? map.getZoom();

  let targetLatlng: LatLngExpression = map.getCenter();

  // if
  if (latlng !== null) {
    if (offset !== null) {
      // Convert latlng to pixel coordinates
      const point = map.project(latlng, targetZoom);

      // Apply the offset (positive x is right, positive y is down)
      const offsetPoint = point.subtract(new Point(offset.x, offset.y));

      // Convert back to LatLng
      targetLatlng = map.unproject(offsetPoint, targetZoom);
    } else {
      targetLatlng = latlng;
    }
  }

  // Fly to the adjusted center
  map.flyTo(targetLatlng, targetZoom, options);
};

const viewportDimensions = () => {
  return [window.innerWidth, innerHeight];
};

export const ZoomControl = ({
  maxZoom,
  bounds,
  zoomLock,
  leftSidebarWidth,
  rightSidebarWidth,
}: {
  maxZoom: number;
  bounds: LatLngBounds | null;
  zoomLock: boolean;
  leftSidebarWidth: number;
  rightSidebarWidth: number;
}) => {
  const map = useMap();
  useEffect(() => {
    if (bounds && !zoomLock) {
      map.flyToBounds(bounds, {
        paddingTopLeft: [leftSidebarWidth, 0],
        paddingBottomRight: [rightSidebarWidth, 0],
        maxZoom: maxZoom,
      });
    }
  }, [bounds, zoomLock]);
  return <></>;
};
